import { render, staticRenderFns } from "./BoxSliderCard.vue?vue&type=template&id=f8803702&scoped=true&"
import script from "./BoxSliderCard.vue?vue&type=script&lang=ts&"
export * from "./BoxSliderCard.vue?vue&type=script&lang=ts&"
import style0 from "./BoxSliderCard.vue?vue&type=style&index=0&id=f8803702&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8803702",
  null
  
)

export default component.exports